import ElementPlus from "element-plus";
import es from "element-plus/es/locale/lang/es";
import "dayjs/locale/es";
import { App } from "vue";

export default (app: App): void => {
  app.use(ElementPlus, { locale: es });
};
